import React, { useState, useEffect } from 'react'
import { getBaseUrl } from '../../Utils'
import { FoundationsEnums } from '../../enum'
import {
    useEditBusinessParameterMutation,
    useGetParameterMutation,
} from '../../Redux/Admin_Tasks/BusinessParameterSlice'
import DatePicker from '../../Components/DatePicker/DatePicker'
import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsInput } from '../../GenericComponents/input'
import FoundationsSelect from '../../GenericComponents/select'
import { FoundationsCheckBox } from '../../GenericComponents/checkbox'
import moment from 'moment'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from "../../Hooks/useTitleContext";
import { useNavigate } from 'react-router-dom'

declare let window: any
const UnicornApp = window.unicornInstance as any
interface formDataedit {
    guid: string
    name: string
    description: string

    _DataType: string
    bpValue: string
    validUntil: string
    isSecured: boolean
}
const BusinessParametersEdit: React.FC = () => {
    const hash = window.location.hash
    const guid = hash.split('?')[1]

    const navigate = useNavigate()

    const { setTitle } = useTitleContext();
    setTitle("Business Parameter Edit");

    const [gettBusinessParameter, { data }] = useGetParameterMutation(guid)
    useEffect(() => {
        gettBusinessParameter(guid)
    }, [gettBusinessParameter])

    const [fielderror, setfielderror] = useState('')
    const [validationMessage, setValidationMessage] = useState('')
    const [dataTypes, setDataTypes] = useState<string[]>([
        FoundationsEnums.HLDataType[FoundationsEnums.HLDataType.HLCount],
        FoundationsEnums.HLDataType[FoundationsEnums.HLDataType.HLNumber],
        FoundationsEnums.HLDataType[FoundationsEnums.HLDataType.HLDuration],
        FoundationsEnums.HLDataType[FoundationsEnums.HLDataType.HLMoney],
    ])
    const [editBusinessParameter, {}] = useEditBusinessParameterMutation()
    const [formDataedit, setFormData] = useState<formDataedit>({
        guid: '',
        name: '',
        description: '',

        _DataType: '',
        bpValue: '',
        validUntil: '',
        isSecured: false,
    })
    const [errors, setErrors] = useState({
        name: '',
        dataType: '',
        bpValue: '',
    })
    const dataTypeMessages = {
        HLCount: 'Up to 10 digits of numbers (without decimals) allowed.',
        HLNumber: 'Up to 10 digits of numbers (with or without decimals) allowed.',
        HLDuration:'Allowed format: dd:hh:mm.ss <br/>Example: <strong>2d:8h:25m</strong> means 2 days, 8 hours and 25 minutes',
        HLMoney: 'Up to 10 digits of numbers with 2 decimals allowed. <br/>No currency symbol allowed.',
    }
    const validateName = () => {
        return formDataedit.name.trim() === '' ? 'Please enter a name.' : ''
    }

    const validateDataType = () => {
        return formDataedit._DataType.trim() === '' ? 'Please select a valid data type.' : ''
    }

    const validateBPValue = () => {
        let regEx
        const datatypefield = formDataedit._DataType
        switch (datatypefield) {
            case 'HLCount':
                regEx = /^\d{1,10}$/
                break
            case 'HLNumber':
                regEx = /^\d{1,10}(?:\.\d{1,2})?$/
                break
            case 'HLDuration':
                regEx =
                    /^(?:(\d{1,3}[dD])(?::([01]?\d|2[0-3])[hH](?::([0-5]?\d)[mM](?::([0-5]?\d)[sS])?)?)?|([01]?\d|2[0-3])[hH](?::([0-5]?\d)[mM](?::([0-5]?\d)[sS])?)?|([0-5]?\d)[mM](?::([0-5]?\d)[sS])?|([0-5]?\d)[sS])$/
                break
            case 'HLMoney':
                regEx = /^\d{1,8}(\.\d{2})$|^100000000(\.00)?$/
                break
            default:
                return 'Please enter a valid value.'
        }
        return regEx.test(formDataedit.bpValue)
            ? ''
            :  'Please enter a valid value'
    }

    const validateForm = () => {
        const nameError = validateName()
        const dataTypeError = validateDataType()
        const bpValueError = validateBPValue()

        setErrors({ name: nameError, dataType: dataTypeError, bpValue: bpValueError })

        return !nameError && !dataTypeError && !bpValueError
    }
    useEffect(() => {
        if (guid && data) {
            setFormData((prevState) => ({
                ...prevState,
                guid: guid,
                validUntil: data.ValidUntilString,
                name: data.Name || prevState.name,
                description: data.Description || prevState.description,
                _DataType: data._DataType || prevState._DataType,
                bpValue: data.BPValue || prevState.bpValue,
                isSecured: data.IsSecured || prevState.isSecured,
            }))
        }
    }, [guid, data])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }))
        let selectedText = ''
        if (e.target instanceof HTMLSelectElement) {
            const selectElement = e.target as HTMLSelectElement
            selectedText = selectElement.options[selectElement.selectedIndex].text
        }

        const updatedValue = type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }))
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }))
        if (name === '_DataType') {
            const selectedTypeID = value as any
            const selectedType = FoundationsEnums.HLDataType[selectedTypeID]
            setFormData((prev) => ({
                ...prev,
                [name]: selectedType,
            }))

            setValidationMessage(
                dataTypeMessages[selectedType as keyof typeof dataTypeMessages] || ''
            )
        }
    }
    const handleDateChange = (date: any) => {
        setFormData((prevState) => ({
            ...prevState,
            validUntil: date ? moment(date).format('MM/DD/YYYY') : '', // Format date as needed
        }))
    }

    const handleSave = async () => {
        document.title = 'Foundations - Manage Business Parameters'
        if (!validateForm()) {
            setfielderror('Please correct the errors below and try again.')
            return
        }

        try {
            await editBusinessParameter(formDataedit).unwrap()
            FoundationsGenericToaster('success', 'Business parameter updated successfully.')
            setTimeout(() => {
                navigate('#BusinessParameters')
            }, 300)
        } catch (error) {
            console.error('Failed to add parameter:', error)
            FoundationsGenericToaster('error', 'Sorry, Business parameter updating failed.')
        }
    }

    const handleCancel = () => {
        navigate('#BusinessParameters')
    }

    if (data) {
        const filteredDataTypes = dataTypes.filter((type) => type !== data._DataType)

        return (
            <>
                <div className="float-right margin-top-small">
                    <a
                        id="link_backto_admin_tasks"
                        className="cursor-pointer"
                        href={`${getBaseUrl()}/ux/index.html#AdminTasks`}
                    >
                        &laquo; Back to Admin Tasks
                    </a>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="header">Manage Business Parameters</div>
                    </div>
                </div>
                <div className="float-right margin-top-small">
                    <a
                        id="BusinessParameters"
                        className="back-to-BP"
                        href={`${getBaseUrl()}/ux/index.html#BusinessParameters`}
                    >
                        &laquo; Back to Business Parameters
                    </a>
                </div>
                <br />
                <br />
                <h5 className="col-sm-offset-1" style={{ marginLeft: '14%' }}>
                    Edit Business Parameter
                </h5>
                <p
                    className="status-box-error margin-bottom-large"
                    style={{ display: fielderror ? 'block ' : 'none' }}
                >
                    {fielderror}
                </p>
                <div className="container">
                    <div
                        className="center-block"
                        style={{ marginLeft: 'auto', marginRight: 'auto' }}
                    >
                        <div className="form-group mt-2 row">
                            <label htmlFor="bp_name" className="control-label col-sm-2 text-right">
                                Name:
                            </label>
                            <div className="col-sm-5">
                                <FoundationsInput
                                    type="text"
                                    inputClasses="form-control"
                                    id="bp_name"
                                    name="name"
                                    value={formDataedit.name}
                                    maxLength={50}
                                    onInput={(e: any) => {
                                        handleInputChange(e)
                                    }}
                                    inputStyle={{ height: '30px', width: '450px' }}
                                />

                                <div
                                    id="valmsg_bp_name"
                                    className="field-validation-error"
                                    style={{ display: errors.name ? 'block' : 'none' }}
                                >
                                    {errors.name}
                                </div>
                            </div>
                        </div>
                        <div className="form-group mt-2 row">
                            <label
                                htmlFor="bp_description"
                                className="control-label col-sm-2 text-right"
                            >
                                Description:
                            </label>
                            <div className="col-sm-5">
                                <FoundationsInput
                                    type="text"
                                    inputClasses="form-control"
                                    id="bp_description"
                                    name="description"
                                    value={formDataedit.description}
                                    onInput={(e: any) => {
                                        handleInputChange(e)
                                    }}
                                    maxLength={100}
                                    inputStyle={{ height: '30px', width: '450px' }}
                                />
                            </div>
                        </div>
                        <div className="form-group mt-2 row">
                            <label htmlFor="bp_scope" className="control-label col-sm-2 text-right">
                                Source:
                            </label>
                            <label htmlFor="bp_scope" className="col-sm-4 control-label align-left">
                                {data.SourceName}
                            </label>
                        </div>
                        <div className="form-group mt-2 row">
                            <label htmlFor="bp_scope" className="control-label col-sm-2 text-right">
                                Scope:
                            </label>
                            <label htmlFor="bp_scope" className="col-sm-2 control-label align-left">
                                {data.ScopeName}
                            </label>
                        </div>
                        <div className="form-group mt-2 row">
                            <label
                                htmlFor="bp_datatype"
                                className="control-label col-sm-2 text-right"
                            >
                                Data Type:
                            </label>
                            <div className="col-sm-4">
                                <FoundationsSelect
                                    id="bp_datatype"
                                    selectClasses="chzn-select"
                                    name="_DataType"
                                    onChange={(e: any) => {
                                        handleInputChange(e)
                                    }}
                                    customStyles={{
                                        width: '200px',
                                        borderColor: '#D3D3D3',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <option value={data.DataType}>{data._DataType}</option>
                                    {filteredDataTypes.map((type: any, index: any) => (
                                        <option
                                            key={index}
                                            value={FoundationsEnums.HLDataType[type]}
                                        >
                                            {type}
                                        </option>
                                    ))}
                                </FoundationsSelect>
                                <div
                                    id="valmsg_bp_datatype"
                                    className="field-validation-error"
                                    style={{ display: errors.dataType ? 'block' : 'none' }}
                                >
                                    {errors.dataType}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group mt-2 row">
                        <label htmlFor="bp_datavalue" className="control-label col-sm-2 text-right">
                            Value:
                        </label>
                        <div className="col-sm-3">
                            <FoundationsInput
                                type="text"
                                inputClasses="form-control"
                                id="bp_datavalue"
                                name="bpValue"
                                value={formDataedit.bpValue}
                                onInput={(e: any) => {
                                    handleInputChange(e)
                                }}
                                inputStyle={{ width: '200px', height: '32px' }}
                                maxLength={10}
                            />

                            <div
                                id="valmsg_bp_datavalue"
                                className="field-validation-error"
                                style={{ display: errors.bpValue ? 'block' : 'none' }}
                            >
                                {errors.bpValue}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div
                                id="dataTypeMessage"
                                className="datatype-message"
                                style={{ color: '#D3D3D3', fontSize: '12px' }}
                                dangerouslySetInnerHTML={{ __html: validationMessage }}
                            >                              
                            </div>
                        </div>
                    </div>

                    <div className="form-group mt-2 row">
                        <label
                            htmlFor="bp_validuntil"
                            className="control-label col-sm-2 text-right"
                        >
                            Valid Until:
                        </label>
                        <div className="col-sm-3">
                            <DatePicker
                                inputClass="form-control bp_validuntil filter-date"
                                value={formDataedit.validUntil}
                                dateFormat="MM/DD/YYYY"
                                style={{ height: '32px' }}
                                placeholder="dd/mm/yyyy"
                                showIcon={false}
                                startingDate={
                                    formDataedit.validUntil
                                        ? moment(formDataedit.validUntil, 'MM/DD/YYYY').toDate()
                                        : null
                                }
                                setStartingDate={handleDateChange}
                                interval={1}
                                showTime={false}
                                onKeyDown={(e) => {
                                    e.preventDefault()
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group mt-2 row">
                        <label htmlFor="bp_isSecured" className="control-label col-sm-2 text-right">
                            IsSecured:
                        </label>
                        <div
                            className="col-sm-3"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                            }}
                        >
                            <FoundationsCheckBox
                                customStyles={{ height: '25px', width: '18px' }}
                                id="bp_isSecured"
                                name="isSecured"
                                checked={formDataedit.isSecured}
                                onChange={(e: any) => {
                                    handleInputChange(e)
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <span
                            className="warning-business-parameter col-sm-offset-0"
                            style={{
                                whiteSpace: 'nowrap',
                                color: 'red',
                                fontSize: '11px',
                                marginRight: '20%',
                            }}
                        >
                            Warning: Business Parameter Values are visible to any users who can edit
                            Summary Report Targets and Report Filters.Sensitive data that should not
                            be available to such users should not be entered as a business
                            parameter.
                        </span>
                    </div>
                    <div className="form-group mt-2 row">
                        <div className="col-sm-offset-2 row" style={{ marginLeft: '16.5%' }}>
                            <div className="col-sm-5">
                                <FoundationsButton
                                    type="button"
                                    buttonClasses="app-button"
                                    onClick={handleSave}
                                    id="edit-button"
                                >
                                    Save
                                </FoundationsButton>
                            </div>
                            <div className="col-sm-5">
                                <FoundationsButton
                                    type="button"
                                    buttonClasses="list-button ui-button app-button negative"
                                    onClick={handleCancel}
                                    id="cancel"
                                >
                                    Cancel
                                </FoundationsButton>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default BusinessParametersEdit
